






















import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IDepartment, IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
const ns = { namespace: 'department' };

@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'department',
  }),
  mixins: [paginationMixin],
})
export default class DepartmentList extends Vue {
  @Action('getEntities', ns) getEntities: () => void;
  @Getter('entitiesSlice', ns) entitiesSlice: IDepartment[];
  @State('pageParams', ns) pageParams: IPageParams;
  headers = [{ text: 'Название', value: 'name' }];
  selected = [];
  interval = null;
  mounted() {
    this.getEntities();
  }
}
